module.exports = __webpack_public_path__ + "img/faceimg.d9365cab.png";